import React from 'react'

import { Divider, Spacer, Container, Row, Col } from '@cleartrip/bento'

import { ReactComponent as FacebookIcon } from 'assets/icons/facebook.svg'
import { ReactComponent as TwitterIcon } from 'assets/icons/twitter.svg'

import {langTranslate} from 'helper/arabic';
import FooterSA from './FooterSA'
import FooterAE from './FooterAE'
import FooterCOM from './FooterCOM'

const Footer = ({ footerTuple = true, isRTL = false,wrapperClass='pt-10' }) => {
  const currentYear = new Date().getFullYear()

  function getFooterTupple() {
    if (!footerTuple) {
      return <></>
    }
    const domain = window.location.hostname
    switch (domain) {
      case 'www.cleartrip.com':
      case 'qa2.cleartrip.com':
      case 'localhost':
        return <FooterCOM />
      case 'www.cleartrip.ae':
      case 'qa2.cleartrip.ae':
        return <FooterAE />
      case 'www.cleartrip.sa':
        return <FooterSA />
      default:
        return <></>
    }
  }
  function getCovidRefund() {
    const domain = window.location.hostname
    switch (domain) {
      case 'www.cleartrip.com':
      case 'qa2.cleartrip.com':
      case 'localhost':
        return true
      default:
        return false
    }
  }
  let getCovidRefundLink = getCovidRefund()
  return (
    <footer className={`footer ${isRTL ? 'direction-rtl' : ''}`}>
      <Spacer className={wrapperClass} />
      <Divider className='bc-neutral-100' />
      <Container>
        <Row>
          <Col className='d-none--xs'>
            <Spacer className='pt-4' />
            <div className='flex flex-between flex-top'>
              <div className='flex flex-column'>
                <ul className='fs-3 flex ls-reset flex-wrap'>
                  <li>
                    <a
                      href='/about'
                      title='About Us'
                      className='fs-3 c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                    >
                      {langTranslate("About Us")}
                    </a>
                  </li>
                  {/* <Spacer className='pr-4' />
                  <li className='fs-3'>
                    <a
                      className='c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                      title='Careers'
                      href='/jobs'
                    >
                      {langTranslate("Careers")}
                    </a>
                  </li> */}
                  <Spacer className='pr-4' />
                  <li>
                    <a
                      className='c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                      href='/faq'
                      title='FAQs'
                    >
                      {langTranslate("FAQs")}
                    </a>
                  </li>
                  <Spacer className='pr-4' />
                  <li>
                    <a
                      className='c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                      href='/support'
                      title='Support'
                    >
                      {langTranslate("Support")}
                    </a>
                  </li>
                  <Spacer className='pr-4' />
                  {/* <li>
                    <a
                      className='c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                      href='http://blog.cleartrip.com'
                      title='Blog'
                    >
                      {langTranslate("Blog")}
                    </a>
                  </li>
                  <Spacer className='pr-4' /> */}
                  {/* <li>
                    <a
                      className='c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                      href='http://www.cleartrip.com/mobile'
                    >
                      {langTranslate("Mobile")}
                    </a>
                  </li>
                  <Spacer className='pr-4' /> */}
                  <li>
                    <a
                      className='c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                      title='Collections'
                      href='/collections'
                    >
                      {langTranslate("Collections")}
                    </a>
                  </li>
                  {/* <Spacer className='pr-4' />
                  <li>
                    <a
                      className='c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                      href='http://www.cleartripforbusiness.com/'
                      title='Cleartrip for Business'
                    >
                      {langTranslate("Cleartrip for Business")}
                    </a>
                  </li> */}
                  <Spacer className='pr-4' />
                  <li>
                    <a
                      className='c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                      href='https://yougotagift.com/shop/en-ae/brands/cleartrip/'
                    >
                      {langTranslate("Gift Cards")}
                    </a>
                  </li>
                  {/* <Spacer className='pr-4' />
                  <li>
                    <a
                      className='fs-3 c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                      title='Holiday Planner'
                      href='https://holidayplanner.cleartrip.com/'
                    >
                      {langTranslate("Holiday Planner")}
                    </a>
                  </li> */}
                </ul>
                <Spacer className='pt-2' />
                <ul className='flex ls-reset'>
                  <li>
                    <span className='fs-2 c-neutral-400'>
                      © {currentYear} Cleartrip MEA FZ LLC
                    </span>
                  </li>
                  <Spacer className='pr-4' />
                  <li>
                    <a
                      className='fs-2 c-neutral-400 td-none hover:td-underline'
                      href='/privacy'
                      title='Privacy'
                    >
                      {langTranslate("Privacy")}
                    </a>
                  </li>
                  <Spacer className='pr-4' />
                  <li>
                    <a
                      className='fs-2 c-neutral-400 td-none hover:td-underline'
                      href='/security'
                      title='Security'
                    >
                      {langTranslate("Security")}
                    </a>
                  </li>
                  <Spacer className='pr-4' />
                  <li>
                    <a
                      className='fs-2 c-neutral-400 td-none hover:td-underline'
                      href='/terms'
                      title='Terms of Use'
                    >
                      {langTranslate("Terms of Use")}
                    </a>
                  </li>
                  <Spacer className='pr-4' />
                  <li>
                    <a
                      className='fs-2 c-neutral-400 td-none hover:td-underline'
                      href='/grievance'
                      title='Grievance Redressal'
                    >
                      {langTranslate("Grievance Redressal")}
                    </a>
                  </li>
                  {getCovidRefundLink && (
                    <>
                      <Spacer className='pr-4' />
                      <li>
                        <a
                          className='fs-2 c-neutral-400 td-none hover:td-underline'
                          href='/pages/lockdown-refund'
                          title='Covid-19 lockdown refund procedure'
                        >
                          Covid-19 lockdown refund procedure
                        </a>
                      </li>
                    </>
                  )}
                </ul>
              </div>
              <div className='flex flex-top'>
                <span className='flex flex-middle nmx-1'>
                  <span className='fs-2 c-neutral-200 mx-1'>Connect</span>
                  <a href='http://facebook.com/cleartrip' className='h-4'>
                    <FacebookIcon
                      height='16px'
                      width='16px'
                      className='mx-1 c-neutral-200'
                    />
                  </a>
                  <a href='http://twitter.com/cleartrip' className='h-4'>
                    <TwitterIcon
                      height='16px'
                      width='16px'
                      className='mx-1 c-neutral-200'
                    />
                  </a>
                </span>
              </div>
            </div>
            <Spacer className='pt-4' />
            {footerTuple && (
              <>
                <Divider />
                <Spacer className='pt-4' />
                {getFooterTupple()}
                <Spacer className='pt-4' />
              </>
            )}
          </Col>
          <Col className='d-block--xs d-none'>
            <Spacer className='pt-4' />
            <div className='flex flex-between flex-top'>
              <div className='flex flex-column'>
                <ul className='fs-2 flex ls-reset flex-wrap'>
                  <li className='mb-1'>
                    <a
                      href='/about'
                      title='About Us'
                      className='fs-2 c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                    >
                      {langTranslate("About Us")}
                    </a>
                  </li>
                  <Spacer className='pr-2' />
                  <li className='mb-1'>
                    <a
                      className='fs-2 c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                      title='Careers'
                      href='/jobs'
                    >
                      {langTranslate("Careers")}
                    </a>
                  </li>
                  <Spacer className='pr-2' />
                  <li className='mb-1'>
                    <a
                      className='fs-2 c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                      href='/faq'
                      title='FAQs'
                    >
                      {langTranslate("FAQs")}
                    </a>
                  </li>
                  <Spacer className='pr-2' />
                  <li className='mb-1'>
                    <a
                      className='fs-2 c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                      href='/support'
                      title='Support'
                    >
                      {langTranslate("Support")}
                    </a>
                  </li>
                  <Spacer className='pr-2' />
                  {/* <li className='mb-1'>
                    <a
                      className='fs-2 c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                      href='http://blog.cleartrip.com'
                      title='Blog'
                    >
                      {langTranslate("Blog")}
                    </a>
                  </li> */}
                  <Spacer className='pr-2' />
                  <li className='mb-1'>
                    <a
                      className='fs-2 c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                      href='http://www.cleartrip.com/mobile'
                    >
                      {langTranslate("Mobile")}
                    </a>
                  </li>
                  <Spacer className='pr-2' />
                  <li className='mb-1'>
                    <a
                      className='fs-2 c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                      title='Collections'
                      href='/collections'
                    >
                      {langTranslate("Collections")}
                    </a>
                  </li>
                  <Spacer className='pr-2' />
                  {/* <li className='mb-1'>
                    <a
                      className='fs-2 c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                      href='http://www.cleartripforbusiness.com/'
                      title='Cleartrip for Business'
                    >
                      {langTranslate("Cleartrip for Business")}
                    </a>
                  </li> */}
                  <Spacer className='pr-2' />
                  <li className='mb-1'>
                    <a
                      className='fs-2 c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                      href='http://www.cleartrip.com/giftcards'
                    >
                      {langTranslate("Gift Cards")}
                    </a>
                  </li>
                  <Spacer className='pr-2' />
                  {/* <li className='mb-1'>
                    <a
                      className='fs-2 c-secondary-500 td-none lh-copy lh-copy--xs hover:td-underline'
                      title='Holiday Planner'
                      href='https://holidayplanner.cleartrip.com/'
                    >
                      {langTranslate("Holiday Planner")}
                    </a>
                  </li> */}
                </ul>
                <Spacer className='pt-2' />

                <div>
                  <span className='fs-1 c-neutral-400'>
                  © {currentYear} Cleartrip MEA FZ LLC
                  </span>
                </div>
                <Spacer className='pr-2' />
                <div className='flex flex-bottom flex-between'>
                  <ul className='flex ls-reset flew-wrap'>
                    <li>
                      <a
                        className='fs-1 c-neutral-400 td-none hover:td-underline'
                        href='/privacy'
                        title='Privacy'
                      >
                        {langTranslate("Privacy")}
                      </a>
                    </li>
                    <Spacer className='pr-2' />
                    <li>
                      <a
                        className='fs-1 c-neutral-400 td-none hover:td-underline'
                        href='/security'
                        title='Security'
                      >
                        {langTranslate("Security")}
                      </a>
                    </li>
                    <Spacer className='pr-2' />
                    <li>
                      <a
                        className='fs-1 c-neutral-400 td-none hover:td-underline'
                        href='/terms'
                        title='Terms of Use'
                      >
                        {langTranslate("Terms of Use")}
                      </a>
                    </li>
                    <Spacer className='pr-2' />
                    <li>
                      <a
                        className='fs-1 c-neutral-400 td-none hover:td-underline'
                        href='/grievance'
                        title='Grievance Redressal'
                      >
                        {langTranslate("Grievance Redressal")}
                      </a>
                    </li>
                  </ul>
                  <Spacer className='pr-2' />
                  {!getCovidRefundLink && (
                    <>
                      {' '}
                      <div className='flex flex-top'>
                        <span className='flex flex-middle nmx-1'>
                          <span className='fs-2 c-neutral-200 mx-1'>
                          {langTranslate("Connect")}
                          </span>
                          <a
                            href='http://facebook.com/cleartrip'
                            className='h-4'
                          >
                            <FacebookIcon
                              height='16px'
                              width='16px'
                              className='mx-1 c-neutral-200'
                            />
                          </a>
                          <a
                            href='http://twitter.com/cleartrip'
                            className='h-4'
                          >
                            <TwitterIcon
                              height='16px'
                              width='16px'
                              className='mx-1 c-neutral-200'
                            />
                          </a>
                        </span>
                      </div>
                    </>
                  )}
                </div>
                {getCovidRefundLink && (
                  <>
                    <div className='flex flex-bottom flex-between'>
                      <ul className='flex ls-reset flew-wrap'>
                        <li>
                          <a
                            className='fs-1 c-neutral-400 td-none hover:td-underline'
                            href='/pages/lockdown-refund'
                            title='Covid-19 lockdown refund procedure'
                          >
                            Covid-19 lockdown refund procedure
                          </a>
                        </li>
                      </ul>

                      <div className='flex flex-top'>
                        <span className='flex flex-middle nmx-1'>
                          <span className='fs-2 c-neutral-200 mx-1'>
                          {langTranslate("Connect")}
                          </span>
                          <a
                            href='http://facebook.com/cleartrip'
                            className='h-4'
                          >
                            <FacebookIcon
                              height='16px'
                              width='16px'
                              className='mx-1 c-neutral-200'
                            />
                          </a>
                          <a
                            href='http://twitter.com/cleartrip'
                            className='h-4'
                          >
                            <TwitterIcon
                              height='16px'
                              width='16px'
                              className='mx-1 c-neutral-200'
                            />
                          </a>
                        </span>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <Spacer className='pt-4' />
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer
